import React, { useState } from "react"
import {
    Box,
    Button,
    Collapse,
    Grid,
    MenuItem,
    Paper,
    TextField,
    Typography,
} from "@material-ui/core"
import { ExpandMore, ExpandLess, Search, Clear } from "@material-ui/icons"
import { makeStyles } from "@material-ui/core/styles"
import { useClientesFornecedorContext } from "../context/useClientesFornecedorContext"
import { ClientesFornecedorActionsTypes } from "../context/clientesFornecedorActions"
import type { FiltroClientes } from "../../../services/clientesFornecedor"

const useStyles = makeStyles(theme => ({
    card: {
        borderRadius: 20,
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        backgroundColor: "white",
        overflow: "hidden",
        marginBottom: theme.spacing(3),
    },
    cardHeader: {
        backgroundColor: "#f8f9fa",
        padding: theme.spacing(2),
        borderBottom: "2px solid #e9ecef",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        cursor: "pointer",
    },
    cardHeaderTitle: {
        fontWeight: 600,
        color: "var(--cor-erro)",
        fontSize: "0.95rem",
    },
    cardContent: {
        padding: theme.spacing(3),
        [theme.breakpoints.down("sm")]: { padding: theme.spacing(2) },
    },
    botoes: {
        display: "flex",
        justifyContent: "center",
        gap: theme.spacing(2),
        marginTop: theme.spacing(2),
    },
    btnPesquisar: {
        borderRadius: 25,
        backgroundColor: "var(--cor-botao-salvar)",
        color: "white",
        boxShadow: "0 2px 8px rgba(var(--cor-botao-salvar-rgb),0.4)",
        "&:hover": { backgroundColor: "var(--cor-botao-salvar-hover)" },
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
    },
    btnLimpar: {
        borderRadius: 25,
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
    },
}))

export function FiltrosClientes() {
    const classes = useStyles()
    const { dados, dispatch, buscar } = useClientesFornecedorContext()
    const [aberto, setAberto] = useState(false)

    const campo = (campo: keyof FiltroClientes, label: string, tipo?: string) => (
        <Grid item xs={12} sm={6} md={4}>
            <TextField
                label={label}
                variant="outlined"
                size="small"
                fullWidth
                type={tipo || "text"}
                value={dados.filtro[campo]}
                onChange={e =>
                    dispatch({
                        type: ClientesFornecedorActionsTypes.ATUALIZAR_FILTRO_CAMPO,
                        payload: { campo, valor: e.target.value },
                    })
                }
            />
        </Grid>
    )

    const handlePesquisar = () => {
        buscar(dados.filtro, 0)
    }

    const handleLimpar = () => {
        dispatch({ type: ClientesFornecedorActionsTypes.LIMPAR_FILTRO })
    }

    return (
        <Paper className={classes.card}>
            <Box className={classes.cardHeader} onClick={() => setAberto(v => !v)}>
                <Typography className={classes.cardHeaderTitle}>Filtros de Busca</Typography>
                {aberto ? <ExpandLess /> : <ExpandMore />}
            </Box>

            <Collapse in={aberto}>
                <Box className={classes.cardContent}>
                    <Grid container spacing={2}>
                        {campo("nome", "Nome")}
                        {campo("email", "E-mail")}
                        {campo("telefone", "Telefone")}
                        {campo("cidade", "Cidade")}
                        {campo("bairro", "Bairro")}

                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                label="Receber notificações manuais"
                                variant="outlined"
                                size="small"
                                fullWidth
                                select
                                value={dados.filtro.spam}
                                onChange={e =>
                                    dispatch({
                                        type: ClientesFornecedorActionsTypes.ATUALIZAR_FILTRO_CAMPO,
                                        payload: { campo: "spam", valor: e.target.value },
                                    })
                                }
                            >
                                <MenuItem value="">Todos</MenuItem>
                                <MenuItem value="1">Sim</MenuItem>
                                <MenuItem value="0">Não</MenuItem>
                            </TextField>
                        </Grid>

                        {campo("diasAusenciaInicio", "Ausentes há mais de (dias)")}
                        {campo("diasAusenciaFinal", "Ausentes há menos de (dias)")}

                        {campo("dataInicioCadastro", "Cadastro de (dd/mm/aaaa)")}
                        {campo("dataFimCadastro", "Cadastro até (dd/mm/aaaa)")}

                        {campo("dataInicioNascimento", "Aniversário de (dd/mm)")}
                        {campo("dataFimNascimento", "Aniversário até (dd/mm)")}

                        {campo("idadeInicio", "Idade mínima")}
                        {campo("idadeFinal", "Idade máxima")}

                        {campo("apenasNaoNotificadsoDias", "Não notificados há (dias)")}
                    </Grid>

                    <Box className={classes.botoes}>
                        <Button
                            variant="contained"
                            className={classes.btnPesquisar}
                            startIcon={<Search />}
                            onClick={handlePesquisar}
                        >
                            Pesquisar
                        </Button>
                        <Button
                            variant="outlined"
                            className={classes.btnLimpar}
                            startIcon={<Clear />}
                            onClick={handleLimpar}
                        >
                            Limpar
                        </Button>
                    </Box>
                </Box>
            </Collapse>
        </Paper>
    )
}
